module.exports = __webpack_public_path__ + "img/34.608639a0.jpg";